/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useContext } from 'react';

const withContext = (Component, context, contextName) => {
   const WrappedComponent = props => (
      <Component {...{ [contextName]: useContext(context), ...props }} />
   );
   return WrappedComponent;
};

export default withContext;
